import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';
import { editPortfolio } from 'services/api/requests/portfolio';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

export const useEditPortfolio = (
	id: number,
	onErrorHierarchyNotFound?: VoidFunction,
	module?: string
) => {
	const queryClient = useQueryClient();
	const history = useHistory();
	const toast = useToast();
	return useMutation((body: any) => editPortfolio(body, id), {
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['carteiraPedido-list'],
			});
			queryClient.invalidateQueries({
				queryKey: ['portfolioWithId', id],
			});
			if (!module) {
				history.goBack();
			}
			toast({
				title: 'Atualizada com sucesso!',
				description: 'Carteira de pedido atualizada com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			if (error?.status === 428 || error?.response?.status === 428) {
				if (onErrorHierarchyNotFound) {
					onErrorHierarchyNotFound();
				}
			} else {
				const toastErrors: Array<any> = mapErrorToToastProps(
					error,
					'Erro ao editar Carteira de Pedido!'
				);
				for (const element of toastErrors) {
					toast(element);
				}
			}
		},
	});
};
